module.exports = __webpack_public_path__ + "img/eleon.745eb91c.png";